module.exports = __webpack_public_path__ + "media/images/lb/794-62b583b8fab899466df44dd8f7491965.svg";